import { Component } from '@angular/core';
import { AppService } from '../../services';

@Component({
  selector: 'app-nav',
  templateUrl: './app-nav.component.html',
  styleUrls: ['./app-nav.component.scss'],
})
export class AppNavComponent{

  appNav = [];
  institutionId;

  constructor(
    private app: AppService,
  ) {

    this.app.getApps().then( data => {
      this.appNav = data;
    });

    this.app.currentInstitution$.subscribe( school => {
      this.institutionId = school.institutionId;
    });

  }

  public getLink(app){
    return [ this.institutionId, app, 'summary' ]
  }


}
